var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcDocTxt = function SvgIcDocTxt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.333 33V106.667C113.333 114.033 107.366 120 99.9993 120H19.9993C12.6327 120 6.66602 114.033 6.66602 106.667V13.3333C6.66602 5.96667 12.6327 0 19.9993 0H80.3327L113.333 33Z",
    fill: "#6D9FE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.334 19.6667V0L113.334 33H93.6673C86.3007 33 80.334 27.0333 80.334 19.6667Z",
    fill: "#4B80CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.334 56.9033H77.0007V50H40.334V56.9033ZM55.214 90.2367H62.1173V56.9033H55.214V90.2367Z",
    fill: "white"
  })));
};
export default SvgIcDocTxt;